var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-manager-list',
  created () {
    utils.backClear()
    this.search(false)
  },
  data () {
    return {
      humanStaffIds: [],
      searchCallbackFlag: false
    }
  },
  computed: {
    humanStaffs () {
      return this.$store.getters.humanStaffs
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var self = this
      var callback = function (){
        for (var i=0; i < self.humanStaffs.length; i++) {
          if (self.humanStaffs[i].attributes['is-human-staff'] == 1) {
            self.humanStaffIds.push(self.humanStaffs[i].id)
          }
        }
        self.searchCallbackFlag = true
      }
      var data = {}
      this.$store.dispatch('HUMAN_STAFF_LIST_SEARCH', {data: data, callback: callback})
    },
    onClickSave: function() {
      var data = {
        'target_ids': this.humanStaffIds
      }
      var self = this
      var callback = function (){
        self.humanStaffIds = []
        for (var i=0; i < self.humanStaffs.length; i++) {
          if (self.humanStaffs[i].attributes['is-human-staff'] == 1) {
            self.humanStaffIds.push(self.humanStaffs[i].id)
          }
        }
        window.alert('保存完了しました。')
        self.$forceUpdate()
      }
      this.$store.dispatch('HUMAN_STAFF_UPDATE', { data: data, callback: callback })
    },
    isCheck: function (id) {
      if (this.humanStaffIds.indexOf(id) >= 0) {
        return 'danger'
      } else {
        return ''
      } 
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/human-staff-list.js